import {toAbsoluteUrl} from '../../../../_metronic/helpers'

export const HomePage = () => {
  return (
    <div className='d-flex align-items-center justify-content-center'>
      <img
        src={toAbsoluteUrl('/media/almamotors/logo.png')}
        className='w-100'
        alt='logo'
        style={{filter: 'contrast(0)', maxWidth: '400px'}}
      />
    </div>
  )
}
